import request from 'Root/request'
import { sanitizeObject } from 'Helpers'

async function getReport(
  url,
  { appCode, startDate, endDate, officeId, patientRef, showArchivedOffices }
) {
  let officeIds = []
  if (officeId) officeIds.push(officeId)
  else
    await request(`/info/offices/list?appCode=${appCode}`).then(
      res =>
        (officeIds = res.data
          .filter(office =>
            showArchivedOffices ? true : office.archived === 'N'
          )
          .map(office => office.id))
    )

  const requests = []
  const responses = []
  for (const officeId of officeIds) {
    requests.push(
      request(
        `${url}?${new URLSearchParams(
          sanitizeObject({
            appCode,
            startDate,
            endDate,
            officeId,
            patientRef,
            showArchivedOffices
          })
        ).toString()}`
      ).then(res => responses.push(res.data))
    )
  }
  await Promise.all(requests)

  return responses
}

function getReportLevel(officeId, patientRef) {
  return officeId ? (patientRef ? 'Patient' : 'Office') : 'App'
}

export { getReport, getReportLevel }
